import { UpsellVariation } from '@src/state/featureFlags/types'

export const upsellNoPlag = (siteNamePlus: string) =>
  `Sign up for ${siteNamePlus}* to see all writing suggestions. Cancel anytime.`
export const UPSELL_CONTROL_PLAG_FOUND =
  'Start a free trial* to see your plagiarism results. Cancel anytime.'
export const UPSELL_VARIATION_PLAG_FOUND =
  'Start a subscription to see your plagiarism results. Cancel anytime.'
export const UPSELL_CONTROL_NO_PLAG =
  'Want to scan for plagiarism too? <b style="font-weight: bold;">Start a 3-day free trial*</b> for a full analysis of your paper. Cancel anytime.'
export const UPSELL_VARIATION_NO_PLAG =
  'Start a subscription to see all writing suggestions. Cancel anytime.'

interface FreemiumModalOveride {
  plagiarismNotFoundCopy: string
  plagiarismFoundCopy: string
  showTermsAndConditions: boolean
}

export const FreemiumPlagiarismCheckModalCSPOverrides: {
  [key in UpsellVariation]: FreemiumModalOveride | null
} = {
  [UpsellVariation.control]: null,
  [UpsellVariation.var1]: {
    plagiarismNotFoundCopy: UPSELL_VARIATION_NO_PLAG,
    plagiarismFoundCopy: UPSELL_VARIATION_PLAG_FOUND,
    showTermsAndConditions: false,
  },
  [UpsellVariation.var2]: {
    plagiarismNotFoundCopy: UPSELL_CONTROL_NO_PLAG,
    plagiarismFoundCopy: UPSELL_CONTROL_PLAG_FOUND,
    showTermsAndConditions: true,
  },
  [UpsellVariation.var3]: {
    plagiarismNotFoundCopy: UPSELL_VARIATION_NO_PLAG,
    plagiarismFoundCopy: UPSELL_VARIATION_PLAG_FOUND,
    showTermsAndConditions: false,
  },
} as const



// WEBPACK FOOTER //
// ./src/state/workspace/constants.ts